import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Notification from "../../../../pages/notifications/Notifications"
import { BackNavIcon } from '../../../../assets/common-svg/CommonSvg';
import { useNavigate } from 'react-router';
import Tags from '../../../pages/Notification/Tags';
import NotifiactionApi from '../../../../services/notofiactionService';
import { notify } from '../../../utils/methods/notification';
import { useSocketInstance } from '../../../../context/SocketContext';
import { useDispatch, useSelector } from 'react-redux';
import { markAsReadChat, selectChatLoading } from '../../../slices/chat';

export default function NotificationContainer() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const isLoading = useSelector(selectChatLoading);
    const [value, setValue] = React.useState('activity');
    const { allNotifiaction, mentions } = useSocketInstance()
    let [renderNotification, setRenderGetNotification] = React.useState(0)
    let [renderTags, setRenderTags] = React.useState(0)
    const [loading, setLoading] = React.useState(false)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleMarkAsAllRead = async () => {
        try {
            if (value === 'activity') {
                setLoading(true)
                NotifiactionApi.markAllReadNotifiaction().then(res => {
                    setRenderGetNotification(renderNotification + 1)
                    notify.success(res?.message)
                }).catch(err => {
                    console.error(err);
                })
            } else if (value == "tags") {
                const res = await dispatch(markAsReadChat()).unwrap();
                if (res?.success == true) {
                    setRenderTags(renderTags + 1)
                    notify.success(res?.message)
                }
            }
        } catch (err) {
            console.error(err);
        }

    }


    return (<div>
        <div className='flex gap-2 m-4 cursor-pointer' onClick={() => navigate(-1)}>
            <BackNavIcon /> Back
        </div>
        <div className='flex flex-col mt-4 ml-4 mr-4 bg-white border border-gray-200 h-full rounded'>
            {/* Tabs + Mark as Read */}
            <Box className="flex justify-between items-center border-b border-gray-200   pt-2">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    textColor="inherit"
                    aria-label="tabs"
                    TabIndicatorProps={{ style: { backgroundColor: '#3571FF' } }}
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '14px',
                            textTransform: 'none',
                            minHeight: '36px',
                            paddingBottom: '8px',
                            color: '#110000', // Inactive tab color
                        },
                        '& .Mui-selected': {
                            color: '#3571FF', // Active tab color
                            fontWeight: 500,
                        }
                    }}
                >
                    <Tab value="activity" label="Activity" />
                    <Tab value="tags" label="Tags" />
                </Tabs>
                {allNotifiaction?.length > 0 && value === 'activity' && (
                    <button
                        onClick={handleMarkAsAllRead}
                        disabled={loading}
                        className={`text-sm pr-4 pb-2 underline ${loading ? "text-gray-400 cursor-not-allowed" : "text-[#3571FF] cursor-pointer"
                            }`}
                    >
                        {loading ? "Marking..." : "Mark as all read"}
                    </button>
                )}

                {mentions?.length > 0 && value === 'tags' && (
                    <button
                        onClick={handleMarkAsAllRead}
                        disabled={isLoading}
                        className={`text-sm pr-4 pb-2 underline ${isLoading ? "text-gray-400 cursor-not-allowed" : "text-[#3571FF] cursor-pointer"
                            }`}
                    >
                        {isLoading ? "Marking..." : "Mark as all read"}
                    </button>
                )}

            </Box>

            {/* Activity Tab Content */}
            {value === 'activity' && (
                <div className="flex flex-col divide-y  text-[13px] text-[#333]">
                    <Notification renderNotification={renderNotification} setLoading={setLoading} loading={loading} />
                </div>
            )}

            {/* Chat and Tags Placeholder */}
            {value === 'chat' && (
                <div className="text-center text-gray-500 p-4">No new chats</div>
            )}
            {value === 'tags' && (
                <div className="text-center text-gray-500 pl-3 pr-3"><Tags renderTags={renderTags} /></div>
            )}
        </div>
    </div>
    );
}
